module.exports = __webpack_public_path__ + "media/music/bells_3-a0ee6515.mp3";